import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { FormlyNgZorroAntdModule } from '@ngx-formly/ng-zorro-antd';
import { TranslateModule } from '@ngx-translate/core';

// Validators
import { JiraControlModule } from '@ep-om/jira-control/jira-control.module';
import { NgZorroModule } from '../ng-zorro/ng-zorro.module';
import { CommonModule } from '@angular/common';

import { FormlyControlComponents } from './index';

@NgModule({
  declarations: [...FormlyControlComponents],
  imports: [
    CommonModule,
    NgZorroModule,
    JiraControlModule,
    ReactiveFormsModule,
    TranslateModule.forChild({ extend: true, isolate: false }),
    FormlyModule,
    FormlyNgZorroAntdModule
  ],
  exports: [...FormlyControlComponents, FormlyModule, FormlyNgZorroAntdModule]
})
export class AppFormlyModule {}
